module.exports = __webpack_public_path__ + "static/media/iot.5ee3d70d.jpg";